/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_BackInputs */

const en_reset_request_back = /** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to sign in`)
};

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const ar_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const he_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const ur_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const es_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const fr_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const de_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const pt_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const hi_reset_request_back = en_reset_request_back;

/** @type {(inputs: Reset_Request_BackInputs) => LocalizedString} */
const bn_reset_request_back = en_reset_request_back;

/**
* | output |
* | --- |
* | "Back to sign in" |
*
* @param {Reset_Request_BackInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_back = /** @type {((inputs?: Reset_Request_BackInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_BackInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_back(inputs)
	if (locale === "he") return he_reset_request_back(inputs)
	if (locale === "ur") return ur_reset_request_back(inputs)
	if (locale === "es") return es_reset_request_back(inputs)
	if (locale === "fr") return fr_reset_request_back(inputs)
	if (locale === "de") return de_reset_request_back(inputs)
	if (locale === "pt") return pt_reset_request_back(inputs)
	if (locale === "hi") return hi_reset_request_back(inputs)
	if (locale === "bn") return bn_reset_request_back(inputs)
	return /** @type {LocalizedString} */ ("Back to sign in")
});